import React from 'react';
import './actionMenu.scss';
import classnames from 'classnames';

export type ActionItem = {
  id: string;
  label: React.ReactNode;
  onClick: () => void;
  onKeyUp: () => void;
};

export type ActionMenuItem = {
  className?: string;
  disabled?: boolean;
  id: string;
  label: string;
  onClick: (e: React.SyntheticEvent) => void;
};

type ActionMenuProps = {
  children: React.ReactNode;
  className?: string;
  items: ActionMenuItem[];
};

const ActionMenu = ({ children, className, items }: ActionMenuProps) => {
  const containerStyles = classnames('action-menu-container', className);

  return (
    <div className={containerStyles}>
      <div className='action-menu-target' tabIndex={0}>
        {children}
      </div>
      <div className='action-menu-items'>
        {items?.map((item) => (
          <button
            key={item.id}
            className={classnames('action-menu-item', item.className)}
            onClick={item.onClick}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                item.onClick(e);
              }
            }}
            tabIndex={0}
            type='button'
            onKeyUpCapture={(e) => e.key === 'Enter' && item.onClick(e)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ActionMenu;
